const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';
const MAGIC_LINK_ENDPOINT = `${API_BASE_URL}/magic-links`;

export interface MagicLinkShortUrlResolution {
  targetPath: string;
}

export interface CustomerDocumentMagicLink {
  artifactId: string;
  documentId: string;
  documentName: string;
  summary?: string | null;
  expiresAt: string;
  downloadUrl: string;
}

export const resolveMagicLinkShortUrl = async (
  code: string
): Promise<MagicLinkShortUrlResolution> => {
  const response = await fetch(
    `${MAGIC_LINK_ENDPOINT}/short/${encodeURIComponent(code)}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    throw new Error('This link is expired or unavailable.');
  }

  return (await response.json()) as MagicLinkShortUrlResolution;
};

export const getCustomerDocumentMagicLink = async (
  artifactId: string
): Promise<CustomerDocumentMagicLink> => {
  const response = await fetch(
    `${MAGIC_LINK_ENDPOINT}/customer-document/${encodeURIComponent(artifactId)}`,
    { method: 'GET' }
  );

  if (!response.ok) {
    throw new Error('This document link is expired or unavailable.');
  }

  return (await response.json()) as CustomerDocumentMagicLink;
};
